import React, {useEffect, useState} from "react";
import {MultiFilterButton, SimpleDropdown} from "common";
import {AuthorizationBillingTabAction, AuthorizationBillingTabFilterValue} from "./AuthorizationBillingTab";
import {
    OfferedHoursStatusMapWithDefault,
    ProcedureCodeWithDefaultValue
} from "../../domain";

type AuthorizationBillingTabFilterProps = {
    initFilterValue: AuthorizationBillingTabFilterValue,
    dispatch: React.Dispatch<AuthorizationBillingTabAction>
}

const AuthorizationBillingTabFilter = ({initFilterValue, dispatch}: AuthorizationBillingTabFilterProps) => {
    const [filterValue, setFilterValue] = useState({...initFilterValue});
    useEffect(() => {
        setFilterValue(initFilterValue);
    }, [initFilterValue])
    const onFilterUpdate = (fieldName: string, fieldValue: any) => {
        setFilterValue({...filterValue, [fieldName]: fieldValue})
    }

    return <MultiFilterButton<AuthorizationBillingTabFilterValue>
        filterValue={filterValue}
        setFilterValue={setFilterValue}
        emptyFilterValue={{
            offeredHourStatus: "At_Risk",
            procedureCode: "",
        }}
        dispatchSetFilterValue={(val) => dispatch({type: "SET_FILTER", filter: val})}
        filterOptions={[
            {
                label: "Offered Hours Status",
                component: <SimpleDropdown
                    options={OfferedHoursStatusMapWithDefault}
                    selected={filterValue.offeredHourStatus}
                    minWidth={"7rem"}
                    textColor={"gray-600"}
                    setSelected={(val) => onFilterUpdate("offeredHourStatus", val)}/>
            },
            {
                label: "Procedure Code",
                component: <SimpleDropdown
                    options={ProcedureCodeWithDefaultValue}
                    selected={filterValue.procedureCode}
                    minWidth={"7rem"}
                    textColor={"gray-600"}
                    setSelected={(val) => onFilterUpdate("procedureCode", val)}/>
            },
        ]}
    />
}

export default AuthorizationBillingTabFilter;